( function( $ ) {

    /**
     * Init zoom.
     */
    initZoomForTarget = function( zoomTarget ) {
        // check if the woocommerce params are present and zoom is enabled with add_theme_support('wc-product-gallery-zoom'); in PHP
        if ( !wc_single_product_params || ! wc_single_product_params.zoom_enabled ) {
            return false;
        }

        var galleryWidth = $(zoomTarget).width(),
            bigImage = '',
            zoomEnabled  = false;

        $( zoomTarget ).each( function( index, target ) {
            var image = $( target ).find( 'img' );

            if ( image.data( 'large_image_width' ) > galleryWidth ) {
                bigImage = image.data('large_image');
                zoomEnabled = true;
                return false;
            }
        } );

        // But only zoom if the img is larger than its container.
        if ( zoomEnabled ) {
            var zoom_options = $.extend( {
                touch: false,
                url: bigImage,
            }, wc_single_product_params.zoom_options );

            if ( 'ontouchstart' in document.documentElement ) {
                zoom_options.on = 'click';
            }

            $(zoomTarget).trigger( 'zoom.destroy' );
            $(zoomTarget).zoom( zoom_options );

            setTimeout( function() {
                if ( $(zoomTarget).find(':hover').length ) {
                    $(zoomTarget).trigger( 'mouseover' );
                }
            }, 100 );
        }
    };


    /*
    * Initialize all image zoom elements on the product page.
    * This uses the Woocommerce zoom functionality
    * The data attribute is added to the element that contains the image
    */
    $('[data-image-zoom]').each(function() {
        initZoomForTarget(this);
    });

} )( jQuery );